<template>
  <div class="applyIng">
    <ApplyNoalert ref="ApplyNoalert" />
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline selectForm"
    >
      <el-form-item label="项目名称：">
        <el-input v-model="formInline.user" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      height="520"
      class="applyTable"
      ref="multipleTable"
      :data="tableDataAll"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="name" label="项目名称" align="left" width="400">
        <template slot-scope="scope">
          <p @click="handleClickDetail">
            <span style="padding-right: 20px;">{{ scope.row.time }}</span
            ><span>编号：2120004000003</span>
          </p>
          <p @click="handleClickDetail">{{ scope.row.name }}</p>
          <p @click="handleClickDetail">
            <i class="el-icon-document-copy"></i><span>招商引资</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="金额" align="center">
        <template slot-scope="scope">
          <p @click="handleClickDetail">
            <i class="el-icon-question"></i>申报：￥{{ scope.row.money }}
          </p>
          <p @click="handleClickDetail">支持|单位</p>
        </template>
      </el-table-column>
      <el-table-column prop="statu" label="全部状态" align="center">
        <template slot-scope="scope">
          <p class="statuColor applying" v-if="scope.row.statu == 2">待提交</p>
          <p @click="handleClickDetail">项目详情</p>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="155">
        <template slot-scope="scope">
          <p>提交</p>
          <p @click="evaluate()">评价</p>
        </template>
      </el-table-column>
    </el-table>
    <div class="applyPagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="3"
      >
      </el-pagination>
    </div>
    <el-dialog
      class="dialog_rate"
      title="评价"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="form-item">
        <span>满意度评价:</span>
        <el-rate v-model="rateValue"></el-rate>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ApplyNoalert from "@/components/ApplyNo_alert.vue";
export default {
  name: "applyIng",
  components: {
    ApplyNoalert,
  },
  data() {
    return {
      formInline: {
        user: "",
        region: "",
      },
      value1: "",
      currentPage: 1,
      tableDataAll: [
        {
          num: "1",
          name: "节能减排科技创新示范企业",
          money: "100万元",
          statu: 2,
          statuReason: "",
          time: "2022-03-14  23:12:00",
        },
        {
          num: "2",
          name: "科技创新小巨人补贴",
          money: "40万元",
          statu: 2,
          statuReason: "",
          time: "2022-03-14  23:15:00",
        },
        {
          num: "3",
          name: "“新三板”挂牌奖励及最高层奖励",
          money: "10万元",
          statu: 2,
          statuReason: "",
          time: "2022-03-16  23:27:02",
        },
      ],
      tableDataAll: [],
      rateValue: null,
      dialogVisible: false,
    };
  },
  methods: {
    onSubmit() {},
    evaluate() {
      this.rateValue = null;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    look() {
      this.$router.push({
        name: "ApplyNo_det",
      });
    },
    appeal() {
      this.$refs.ApplyNoalert.show({
        type: 1,
      });
    },
    upload() {
      this.$refs.ApplyNoalert.show({
        type: 2,
      });
    },
    download() {},
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleClickDetail() {
      this.$router.push({
        name: "declareDetail",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.applyIng {
  .applyTab {
    border-top: 2px solid #e4e7ed;
    /deep/.el-tabs__item {
      padding: 0 20px;
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      color: rgba(56, 56, 56, 1);
    }
    /deep/.selectForm {
      .el-form-item {
        margin-right: 5%;
      }
      .el-date-editor .el-range-separator {
        width: 10%;
      }
    }
  }
  .applyTable {
    /deep/.has-gutter tr th {
      background-color: rgba(250, 250, 250, 1);
    }
    .statuColor::before {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 5px;
    }
    .applying::before {
      background-color: rgba(24, 144, 255, 1);
    }
    .applypass::before {
      background-color: rgba(67, 207, 124, 1);
    }
    .applyreject::before {
      background-color: rgba(245, 34, 45, 1);
    }
    .uploaddata::before {
      background-color: rgb(25, 207, 231);
    }
    .tocash::before {
      background-color: rgba(255, 141, 26, 1);
    }
    .givrup::before {
      background-color: rgba(0, 0, 0, 0.25);
    }
  }
  .applyPagination {
    text-align: right;
    margin-top: 10px;
  }
  .dialog_rate {
    /deep/ .el-dialog {
      margin-top: 20% !important;
      .form-item {
        display: flex;
        span {
          height: 28px;
          line-height: 28px;
          margin-right: 20px;
        }
        .el-rate {
          height: 30px;
          line-height: 30px;
          .el-rate__item {
            margin-right: 0;
            .el-rate__icon {
              font-size: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
